import { IDeepLinkInfo, IGraphicSize } from '@gem/models/commonModel';

export interface IStickerPack {
  id: string;
  order: number;
  displayName: string;
  iconUrl: string;
  isPrivate: boolean;
  isSharable: boolean;
  deepLink: IDeepLinkInfo;
}

export enum StickerType {
  Animated = 'ANIMATED',
  Static = 'STATIC',
}

export interface ISticker {
  id: string;
  order: number;
  stickerPackId: string;
  stickerUrl: string;
  displayName: string;
  animationUrl?: string;
  graphicSize: IGraphicSize;
  type: StickerType;
}

export interface IStickerPacksList {
  cursor: string | null;
  items: IStickerPackExtend[];
}

export interface IStickerPackExtend {
  stickerPack: IStickerPack;
  stickers: ISticker[];
}

export interface IUserStickerPacks {
  items: IStickerPackExtend[];
}

export interface IStickerPackRequest {
  stickerPackId: string;
}

export type IUserStickerPacksUpdatedEventPayload = {
  stickerPacks: string[];
};
export type IStickerPackUpdatedEventPayload = {
  stickerPackId: string;
};
